import React from 'react';
import { translate } from 'react-i18next';
import {Button, Label, Icon, Header} from 'semantic-ui-react'

import SurveyButtons from './SurveyButtons.js';
import {colors, fontSizes, fonts, spacings, shadow} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    header: {
        fontSize: fontSizes.h2,
        lineHeight: '1.5',
        color: colors.themeBlue,
        marginBottom: '20px'
    },
    pointsLabel: {
        fontSize: '14px',
        display: 'inline-block',
        color: '#fff',
        backgroundColor: colors.pointsYellow,
        height: '26px',
        borderRadius: '13px',
        padding: '6px 16px 6px 3px',
        verticalAlign: 'middle',
        margin: '0px 5px 0px 5px',
    },
    resourceLabel: {
        fontSize: '14px',
        display: 'inline-block',
        color: '#fff',
        backgroundColor: colors.themeBlue,
        height: '26px',
        borderRadius: '13px',
        padding: '6px 16px 6px 3px',
        verticalAlign: 'middle',
        margin: '0px 5px 0px 5px',
    },
    startButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeTeal,
        color: '#fff',
        width: '330px',
        boxShadow: shadow,
        marginBottom: spacings.base,
    },
    icon: {
        padding: '0px 12px 6px 8px',
        verticalAlign: 'middle',
        fontSize: '16px',
        position: 'relative',
        top: '-1px',
    },
    iconSpan: {
        position: 'relative',
        top: '-3px',
    },
}

const SurveyPageWelcome = ({t, surveyPage, onSubmit, onSkip, inlineButtons}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>

            <Header style={style.header}>
                {surveyPage.title}
            </Header>

            {Boolean(surveyPage.welcome) &&
            <div>
                <div style={style.pointsLabel}>  
                    <span style={style.iconSpan}>
                        <i style={style.icon} className="icon-star"/>
                        {surveyPage.welcome.points}
                    </span>
                </div>
                <div style={style.resourceLabel}>
                    <span style={style.iconSpan}>
                        <i style={style.icon} className="icon-Optimollar"/>
                        {surveyPage.welcome.resources}
                    </span>
                </div>
            </div>
            }

            <div style={style.description}>
                {surveyPage.description}
            </div>
            <SurveyButtons onSubmit={onSubmit} inlineButtons={inlineButtons} />

            <div style={style.spacer} />       
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPageWelcome);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageWelcome.js